<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper">
    <div class="behaviour-card-sec">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{
            caseParams.case?.student?.firstName +
              ' ' +
              caseParams.case?.student?.lastName
          }}
        </h3>
      </div>
      <div class="card-content-wrapper">
        <div class="content">
          <h4 class="title">Date Of Birth</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-calendar.svg"
              class="icon s-16"
              aria-label="Calendar"></svg-icon>
            {{
              caseParams.case?.student?.dateOfBirth ?? null | date: 'MM/dd/yyyy'
            }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Supervisor</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-supervisor.svg"
              class="icon s-16"
              aria-label="Supervisor"></svg-icon>
            {{ caseParams.case?.supervisorName }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Gender</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-male.svg"
              class="icon s-18"
              aria-label="Male"></svg-icon>
            {{ caseParams.case?.student?.gender }}
          </p>
        </div>
      </div>
    </div>

    <div>
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{ caseParams.behavior?.behaviorCategoryName }}
        </h3>
      </div>
      <h4 class="title s-16 mb-16">Behavior</h4>
      <div class="behavior-badge-wrapper">
        <span
          class="badge"
          *ngFor="let behavior of caseParams.behavior?.behaviorCategoryTypes">
          {{ behavior.behaviorTypeName }}
        </span>
      </div>
    </div>
    <nz-divider class="sec-divider" />
    <nz-table
      #basicTable
      [nzData]="listOfData"
      [nzShowPagination]="false"
      [nzScroll]="{ x: '700px', y: 'calc(100vh - 300px)' }">
      <thead>
        <tr>
          <th scope="col" nzWidth="400px">Name</th>
          <th scope="col" nzWidth="350px"></th>
          <th scope="col" nzWidth="100px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data; let i = index">
          <td nzWidth="400px">{{ data.name }}</td>
          <td nzWidth="300px">
            <div class="action-btn-wrapper" *ngIf="data.isEnabled">
              <button
                nz-button
                nzType="default"
                (click)="openEnterDataDrawer(i + 1)">
                Enter Data
              </button>
              <button
                nz-button
                nzType="default"
                (click)="openDataGraphsDrawer(i + 1)">
                Graph
              </button>
              <button
                nz-button
                nzType="default"
                (click)="printDatasheet(i + 1, data)"
                [nzLoading]="data.isPrintLoading">
                Datasheet
              </button>
            </div>
          </td>
          <td nzWidth="100px">
            <button
              nz-button
              nzType="text"
              class="primary-text-btn"
              *ngIf="i > 0"
              (click)="toggleData(data.isEnabled, i + 1)">
              {{ !data.isEnabled ? 'Enable' : 'Disable' }}
            </button>
          </td>
        </tr>
      </tbody></nz-table
    >
    <div class="display-flex justify-content-between drawer-footer">
      <div class="footer-right">
        <button
          *ngIf="caseParams.isContinueProcessing || false"
          nz-button
          type="button"
          nzType="default"
          (click)="openDetailsDrawer()">
          Go to details
        </button>
      </div>
    </div>
  </div>
  <app-confirm-dialog
    [isVisible]="showConfirmDialog"
    [title]="'Disable Datasheet'"
    message="Are you sure you want to disable this datasheet?"
    [iconSrc]="'/assets/icon/icon-trash-red.svg'"
    [iconColor]="'red'"
    [cancelText]="'Cancel'"
    [confirmText]="'Disable'"
    [loading]="isDeleting"
    (confirmed)="removeDatasheet()"
    (cancelled)="handleCancel()"
    (closed)="handleCancel()">
  </app-confirm-dialog>

  <ng-template #drawerTitleEnterData>
    <app-drawer-header
      [title]="'Data'"
      [subtitle]="''"
      [breadcrumbText]="''"
      (drawerClose)="closeEnterDataDrawer()">
    </app-drawer-header>
  </ng-template>

  <ng-template #drawerTitleDataGraph>
    <app-drawer-header
      [title]="'Data'"
      [subtitle]="''"
      [breadcrumbText]="''"
      (drawerClose)="closeDataGraphDrawer()">
    </app-drawer-header>
  </ng-template>
</nz-spin>
